import React, { FC } from 'react';
import { useForm } from 'react-hook-form';
import { ISelectOptionProps } from 'components/form/types';
import { useHistory, useParams } from 'react-router';
import { useModal } from 'store/modal';
import { useActiveClientContext } from 'store/active-client';
import { buildClientUrl, buildClientEntity } from 'utils/helpers/client';
import CreateEntity from 'components/crud/CreateEntity';
import ElementForm from './ElementForm';
import { IInputs } from '../types';
import { formatDataOnSubmit } from '../dataFormatters';

interface IProps {
  elementsEntityName: string;
  segmentIdKey: string;
  identifierOptions?: ISelectOptionProps[];
}

const CreateForm: FC<IProps> = ({ elementsEntityName, segmentIdKey, identifierOptions }) => {
  const { showModal } = useModal();
  const { client } = useActiveClientContext();
  const { segmentId } = useParams<{ segmentId?: string }>();
  const methods = useForm<IInputs>({
    defaultValues: {
      is_active: true,
    },
  });
  const history = useHistory();

  return (
    <CreateEntity
      entity={elementsEntityName}
      methods={methods}
      onSuccess={(res: any) => {
        const { id, name, tokens } = res.data;
        const nextPage =
          tokens.length > 0
            ? buildClientUrl(`/segments/${segmentId}/elements/manage-tokens/${id}`, client)
            : buildClientUrl(`/segments/edit/${segmentId}`, client);
        history.push({
          pathname: nextPage,
          state: {
            isEdit: false,
            elementName: name,
          },
        });
        if (!tokens.length) {
          showModal({
            type: 'success',
            content: (
              <>
                Създадохте елемент&nbsp;
                <span className="font-weight-bold">{name}</span>.
              </>
            ),
          });
        }
      }}
      queryKey={buildClientEntity(elementsEntityName, client)}
    >
      {(create: any) => (
        <ElementForm
          methods={methods}
          handleSubmit={data =>
            create(
              formatDataOnSubmit({
                ...data,
                [segmentIdKey]: segmentId,
              })
            )
          }
          btnLabel="Запази"
          isMultilingual={client?.is_multilingual}
          identifierOptions={identifierOptions}
        />
      )}
    </CreateEntity>
  );
};

export default CreateForm;
